import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import drugData from '../data/drugs.json';

export default function DrugGuide() {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Arama Filtresi
    const filteredDrugs = drugData.filter(drug => 
        drug.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        drug.active_ingredient?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div style={containerStyle}>
            <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '10px' }}>📚 Veteriner İlaç Rehberi</h2>
            <p style={{ textAlign: 'center', color: '#7f8c8d', fontSize: '13px', marginBottom: '20px' }}>Klinik Etken Madde ve Dozaj Veritabanı</p>
            
            {/* Arama Kutusu */}
            <div style={searchContainer}>
                <input 
                    type="text" 
                    placeholder="İlaç veya etken madde ara..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={searchStyle}
                />
            </div>

            {/* İlaç Listesi */}
            <div style={listContainer}>
                {filteredDrugs.length > 0 ? (
                    filteredDrugs.map((drug) => (
                        <div 
                            key={drug.id} 
                            onClick={() => navigate(`/drug/${drug.id}`)} 
                            style={cardStyle}
                        >
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={drugName}>{drug.name}</div>
                                <div style={activeIng}>{drug.active_ingredient}</div>
                            </div>
                            <div style={arrowStyle}>➔</div>
                        </div>
                    ))
                ) : (
                    <div style={noResultStyle}>
                        🔍 "{searchTerm}" ile eşleşen bir ilaç bulunamadı.
                    </div>
                )}
            </div>
        </div>
    );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    padding: '15px', 
    maxWidth: '600px', 
    margin: '0 auto', 
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', 
    paddingBottom: 'env(safe-area-inset-bottom)'      
};

const searchContainer = { position: 'relative', marginBottom: '20px', boxSizing: 'border-box' };

const searchStyle = { 
    width: '100%', 
    padding: '15px 20px', 
    borderRadius: '15px', 
    border: '2px solid #dfe6e9', 
    fontSize: '16px', 
    boxSizing: 'border-box', 
    outline: 'none', 
    boxShadow: '0 4px 10px rgba(0,0,0,0.03)', 
    transition: 'border-color 0.3s',
    WebkitAppearance: 'none'
};

const listContainer = { display: 'flex', flexDirection: 'column', gap: '12px', boxSizing: 'border-box' };

const cardStyle = { 
    background: '#fff', 
    padding: '18px', 
    borderRadius: '15px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)', 
    cursor: 'pointer', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between', 
    transition: 'transform 0.2s, box-shadow 0.2s', 
    border: '1px solid #f1f2f6',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent'
};

const drugName = { fontWeight: 'bold', color: '#2c3e50', fontSize: '17px', marginBottom: '4px', wordBreak: 'break-word' };
const activeIng = { fontSize: '13px', color: '#7f8c8d', fontStyle: 'italic', wordBreak: 'break-word' };
const arrowStyle = { color: '#3498db', fontSize: '20px', marginLeft: '15px', flexShrink: 0 };

const noResultStyle = { textAlign: 'center', color: '#95a5a6', marginTop: '30px', padding: '20px', background: '#f8f9fa', borderRadius: '12px', boxSizing: 'border-box' };